import type { IconColor, IconComponent } from '@alltrails/denali/components/Icon';
import Caution from '@alltrails/denali/icons/Caution';
import CautionFilled from '@alltrails/denali/icons/CautionFilled';
import Closure from '@alltrails/denali/icons/Closure';
import ClosureFilled from '@alltrails/denali/icons/ClosureFilled';
import ErrorIcon from '@alltrails/denali/icons/Error';
import ErrorFilled from '@alltrails/denali/icons/ErrorFilled';
import Info from '@alltrails/denali/icons/Info';
import InfoFilled from '@alltrails/denali/icons/InfoFilled';
import { AlertType } from '@alltrails/types/Alert';

export const alertTypeIconColor: Record<AlertType, IconColor> = {
  [AlertType.CLOSURE]: '--color-text-error',
  [AlertType.DANGER]: '--color-text-error',
  [AlertType.WARNING]: '--color-text-caution',
  [AlertType.INFORMATION]: '--color-text-info'
};

export const alertTypeIcon: Record<AlertType, IconComponent> = {
  [AlertType.CLOSURE]: Closure,
  [AlertType.DANGER]: ErrorIcon,
  [AlertType.WARNING]: Caution,
  [AlertType.INFORMATION]: Info
};

export const alertTypeIconFilled: Record<AlertType, IconComponent> = {
  [AlertType.CLOSURE]: ClosureFilled,
  [AlertType.DANGER]: ErrorFilled,
  [AlertType.WARNING]: CautionFilled,
  [AlertType.INFORMATION]: InfoFilled
};
